import { getCurrentTenant } from "./tenantConfig";

const tenant = getCurrentTenant();

const KEYCLOAK_CONFIG = {
  realmUrl: `${tenant?.keycloakHost}/realms/${tenant?.projectCode}`,
  clientId: "DefaultClient",
  redirectUri: window.location.origin + "/login",
  silentRedirectUri: window.location.origin + "/silent-auth.html",
};

// if (tenant.projectCode === "RCU") {
//   KEYCLOAK_CONFIG.clientId = "DevDefaultClient";
// }

if (tenant.localeOverride === "SARJ") {
  KEYCLOAK_CONFIG.clientId = "SarjDefaultClient";
}

if (process.env.NODE_ENV === "development") {
  KEYCLOAK_CONFIG.clientId = "DevDefaultClient";
}

// if (process.env.NODE_ENV === "development") {
//   KEYCLOAK_CONFIG.clientId = "DevDefaultClient";
// }

export default KEYCLOAK_CONFIG;
